var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRNewOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-order-out",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.87,4.583l-0.005,-0.003c-1.076,-0.621 -2.46,-0.25 -3.083,0.83c-0,0 -6.037,10.456 -6.037,10.456c-0.624,1.081 -1.384,4.422 -0.303,5.046c1.08,0.624 3.594,-1.705 4.218,-2.785c0,-0 6.037,-10.456 6.037,-10.456c0.624,-1.081 0.253,-2.464 -0.827,-3.088Zm-11.38,13.56l-6.736,-0c-0.416,-0 -0.754,0.338 -0.754,0.753c-0,0.416 0.338,0.754 0.754,0.754l6.648,0c-0.082,-0.58 -0.016,-1.005 0.088,-1.507Zm10.626,-12.255c-0.36,-0.208 -0.821,-0.084 -1.029,0.276l-6.037,10.456c-0.208,0.36 -1.215,2.779 -0.855,2.987c0.361,0.208 1.952,-1.873 2.16,-2.234l6.037,-10.456c0.208,-0.36 0.084,-0.821 -0.276,-1.029Zm-9.156,8.487l-8.219,0c-0.409,0 -0.741,0.338 -0.741,0.754c-0,0.416 0.332,0.753 0.741,0.753l7.34,0c-0.004,-0.001 0.142,-0.258 0.172,-0.344c0.085,-0.247 0.707,-1.163 0.707,-1.163Zm2.098,-3.767l-10.304,-0c-0.416,-0 -0.754,0.337 -0.754,0.753c-0,0.416 0.338,0.754 0.754,0.754l9.432,-0l0.872,-1.507Zm1.308,-2.261l0.869,-1.502c-0.03,-0.003 -12.481,-0.005 -12.481,-0.005c-0.416,-0 -0.754,0.337 -0.754,0.753c-0,0.416 0.338,0.754 0.754,0.754l11.612,-0Zm1.968,-4.521c0,-0.416 -0.337,-0.754 -0.753,-0.754l-12.827,0c-0.416,0 -0.754,0.338 -0.754,0.754c-0,0.416 0.338,0.753 0.754,0.753l12.827,0c0.416,0 0.753,-0.337 0.753,-0.753Z",
    style: {
      fill: "#808080"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph-megaphone-light"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRNewOrder);
export default __webpack_public_path__ + "static/media/iconR-new-order.d21736913bae212c5ad2fb9298254ebc.svg";
export { ForwardRef as ReactComponent };